import { Box, Container, Typography, Paper } from '@mui/material';

const PrivacyPolicy = () => {
	return (
		<Container maxWidth="md" sx={{ py: 4 }}>
			<Paper elevation={1} sx={{ p: 4 }}>
				<Typography variant="h4" gutterBottom>
					Privacy Policy
				</Typography>

				<Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
					WhatsApp Integration
				</Typography>
				<Typography paragraph>
					Our service integrates with WhatsApp's Business API for communication purposes. When you use our service:
				</Typography>
				<Box component="ul" sx={{ pl: 4 }}>
					<Typography component="li">We collect and process your phone number to enable WhatsApp communication</Typography>
					<Typography component="li">Messages sent through WhatsApp are subject to WhatsApp's own privacy policy</Typography>
					<Typography component="li">We use WhatsApp to send login OTPs, notifications, and service-related updates</Typography>
				</Box>

				<Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
					Information We Collect
				</Typography>
				<Typography paragraph>
					We collect the following information to provide our services:
				</Typography>
				<Box component="ul" sx={{ pl: 4 }}>
					<Typography component="li">Phone number for authentication and communication</Typography>
					<Typography component="li">Shop and location details</Typography>
					<Typography component="li">Usage data and service interaction logs</Typography>
					<Typography component="li">Device and browser information</Typography>
				</Box>

				<Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
					How We Use Your Information
				</Typography>
				<Typography paragraph>
					Your information is used for:
				</Typography>
				<Box component="ul" sx={{ pl: 4 }}>
					<Typography component="li">Authentication and account management</Typography>
					<Typography component="li">Providing our core salon management services</Typography>
					<Typography component="li">Sending important notifications and updates</Typography>
					<Typography component="li">Improving our services and user experience</Typography>
				</Box>

				<Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
					Data Security
				</Typography>
				<Typography paragraph>
					We implement appropriate security measures to protect your personal information from unauthorized access,
					alteration, disclosure, or destruction. Your data is encrypted during transmission and storage.
				</Typography>

				<Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
					Last updated: May 5, 2025
				</Typography>
			</Paper>
		</Container>
	);
};

export default PrivacyPolicy;
